export const getDraftPreview = (draft) => draft.preview;
